import { deserializeLinkAsset } from "../../src/entities/LinkAsset";
import { AssetCategory } from "../../src/entities/AssetCategory";
import { WebClient } from "./server/WebClient";

export interface SaveLinkAssetRequest {
    id?: string; 
    parentId?: string; 
    name: string;
    isStarred: boolean;
    dateAccessed: Date;
    category: AssetCategory;
    url: string;
    datePreached?: Date;
    locationPreached: string;
    scripture: string;
}

export const LinkAssetService = {
    get: (id: string) => WebClient.Get(`api/LinkAssets/GetLinkAsset/${id}`, deserializeLinkAsset),
    save: (fileAssetToSave: SaveLinkAssetRequest) => WebClient.Post.Validated(`api/LinkAssets/SaveLinkAsset/`, fileAssetToSave, deserializeLinkAsset),
    delete: (id: string) => WebClient.Delete(`api/LinkAssets/DeleteLinkAsset/${id}`),
    getRedirectUrl: (id: string) => `api/LinkAssets/GoTo/${id}`,
    undelete: (id: string) => WebClient.Put.Validated(`api/LinkAssets/UndeleteLinkAsset/`, {id}, deserializeLinkAsset),
    setName: (id: string, name: string) => WebClient.Put.Validated(`api/LinkAssets/SetNameLinkAsset/`, {id, name}, deserializeLinkAsset),
    setStarred: (id: string, isStarred: boolean) => WebClient.Put.Validated(`api/LinkAssets/SetStarredLinkAsset`, {id, isStarred}, deserializeLinkAsset),
    move: (id: string, parentId: string | null) => WebClient.Put.Validated(`api/LinkAssets/MoveLinkAsset`, {id, parentId}, deserializeLinkAsset)
}